<template>
	<v-form>
		<h1 style="text-align:center;">SBC Private Water Inquiry Form</h1>
		<v-text-field outlined label="Enter Full Name" v-model="data.name" />
		<v-text-field outlined label="Enter Email" v-model="data.email" />
		<v-text-field outlined label="Enter Phone Number" v-model="data.phone" />
		<v-text-field outlined label="Enter Group Size" v-model="data.groupSize" />
		<v-text-field outlined label="Enter Prefered Dates" v-model="data.dates" />

		<v-btn
			v-if="!loading"
			text
			block
			class="grey lighten-2 mb-5"
			v-on:click="inquire()"
			:disabled="isSignupDisabled()"
		>
			Inquire
		</v-btn>
		<div class="loader-container" v-if="loading"><div class="loader" /></div>
		<v-alert type="success" v-if="success">
			Thank you for your Inquiry, one of our shop team members will be in touch
			with you to book your trip.
		</v-alert>
		<v-alert type="warning" v-if="error">
			An issue occured processing your inquiry. Please call the shop at
			303-447-2400 for more information.
		</v-alert>
	</v-form>
</template>
<script>
import fb from "@/fb";
export default {
	data() {
		return {
			data: {
				name: "",
				email: "",
				phone: "",
				groupSize: "",
				dates: "",
			},
			success: false,
			error: false,
			loading: false,
		};
	},
	methods: {
		inquire: async function() {
			this.loading = true;
			const sendSBCPrivateInquiry = fb.functions.httpsCallable(
				"sendSBCPrivateInquiry"
			);
			const response = await sendSBCPrivateInquiry(this.data);
			response.data ? (this.success = true) : (this.error = true);
			this.loading = false;
		},
		isSignupDisabled: function() {
			return (
				!this.data.name ||
				!this.data.email ||
				!this.data.phone ||
				!this.data.groupSize ||
				!this.data.dates
			);
		},
	},
};
</script>
<style scoped>
a {
	text-decoration: none;
	color: black;
}
.loader-container {
	display: flex;
	justify-content: center;
}
.loader {
	border: 5px solid #f3f3f3; /* Light grey */
	border-top: 5px solid #3498db; /* Blue */
	border-radius: 50%;
	width: 50px;
	height: 50px;
	animation: spin 1s linear infinite;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>
